import GtagHelper, { EventCategory, EventAction, EventLabel } from 'common/helpers/gtag'

export const sendAcceptEvent = () => GtagHelper.interaction({
  category: EventCategory.TermConditions,
  action: EventAction.ClickTermAccept,
  label: EventLabel.Accept
})
